import http from "./http";
import useAuthToken from "./useAuthToken";
import useErrorHandling from "./useErrorHandling";

export default function useApiHelpers() {
  const getRequest = async (endpoint, callback) => {
    const { handleServerErrors } = useErrorHandling();
    const { fetchAuthToken } = useAuthToken();

    try {
      const token = await fetchAuthToken();

      return http
        .get(endpoint, {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          if (callback) {
            callback(response);
          }
          return response;
        })
        .catch((err) => {
          handleServerErrors(err);
        });
    } catch (err) {
      throw new Error(err);
    }
  };

  const postRequest = async (
    endpoint,
    payload,
    callbackOnSuccess,
    callbackOnError,
    opts = {
      headers: {},
    },
    throwOnError = true
  ) => {
    const { handleServerErrors, handleMappedErrorResponses } =
      useErrorHandling();
    const { fetchAuthToken } = useAuthToken();
    try {
      const token = await fetchAuthToken();
      return http
        .post(endpoint, payload, {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${token}`,
            ...opts.headers,
          },
        })
        .then((response) => {
          if (callbackOnSuccess) {
            callbackOnSuccess(response);
          } else {
            console.error("Callback on success not specified");
          }
        })
        .catch((err) => {
          console.error(`${err}`);

          const {
            status,
            data: { code, errors },
          } = err.response;
          if (status === 422 && callbackOnError) {
            callbackOnError(handleMappedErrorResponses(code, errors));
            return;
          }
          if (throwOnError === true) {
            handleServerErrors(err);
          }

          if (callbackOnError) {
            callbackOnError();
          }
        });
    } catch (err) {
      throw new Error(err);
    }
  };

  const multiPostRequests = async (promises, callback) => {
    const { handleServerErrors } = useErrorHandling();

    try {
      return Promise.all(promises)
        .then((response) => {
          callback(response);
        })
        .catch((err) => {
          handleServerErrors(err);
        });
    } catch (err) {
      throw new Error(err);
    }
  };

  return {
    getRequest,
    postRequest,
    multiPostRequests,
  };
}
